import styled from "styled-components"

export const Wrapper = styled.div`
  height: 300px;
  padding: 16px;
  padding-bottom: 24px;
`
